// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1-FIW","choiceBoxes":"toolbarselects_choiceBoxes__3xmJn","simpleField":"toolbarselects_simpleField__11vbw"};